import {Injectable, TemplateRef} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {FroalaCodeViewFlushService} from '../froala/froala-code-view-flush.service';

/** Connects question cards to the editor's shared property panel. */
export interface QuestionInspectorSelection {
  question: Questionnaire.Container;
  template: TemplateRef<any>;
}

/** Keeps selection local to one editor and flushes rich text before switching. */
@Injectable()
export class QuestionnaireInspectorService {
  public readonly selection = new BehaviorSubject<QuestionInspectorSelection>(null);
  public requestedQuestion: Questionnaire.Container = null;
  private revision = 0;
  private pendingTemplate: TemplateRef<any> = null;

  /** Injects the existing rich text synchronization service. */
  public constructor(private codeViewFlush: FroalaCodeViewFlushService) {}

  /** Opens properties after pending rich text has reached the question model. */
  public async select(selection: QuestionInspectorSelection): Promise<void> {
    if (this.selection.value?.template === selection.template && !this.pendingTemplate) {
      return;
    }
    this.pendingTemplate = selection.template;
    const revision = ++this.revision;
    await this.codeViewFlush.flushAll();
    if (revision === this.revision) {
      this.pendingTemplate = null;
      this.requestedQuestion = null;
      this.selection.next(selection);
    }
  }

  /** Drops a panel whose card was removed or left the current page. */
  public release(template: TemplateRef<any>): void {
    if (this.pendingTemplate === template) {
      ++this.revision;
      this.pendingTemplate = null;
    }
    // card destruction can happen while the parent view is being checked
    Promise.resolve().then(() => {
      if (this.selection.value?.template === template) {
        this.selection.next(null);
      }
    });
  }
}
